import useTranslation from "@hooks/use_translation.ts";
import formatPhoneNumber from "@utils/phone.ts";
import SectionDetailList from "@components/profile/section_detail_list.tsx";
import type { ProfileData } from "@/queries/use_profile.ts";

type Props = {
  data: ProfileData;
};

const ContactInfoBody = ({ data }: Props) => {
  const { t } = useTranslation("user", { keyPrefix: "profile_sections.contact_info" });

  return (
    <SectionDetailList
      rows={[
        { label: t("first_name"), value: data.firstName },
        { label: t("last_name"), value: data.lastName },
        { label: t("preferred_name"), value: data.preferredName },
        {
          label: t("phone_number"),
          value: data.phoneNumber ? formatPhoneNumber(data.phoneNumber) : null,
        },
        { label: t("location"), value: data.location?.display_name },
      ]}
    />
  );
};

export default ContactInfoBody;
